import React from 'react';
import Image from '../../platformui/Image';

/**
 * @typedef CheckboxWithImgProps
 * @property {string | undefined} id
 * @property {string | undefined} name
 * @property {string} text
 * @property {boolean} checked
 * @property {React.ChangeEventHandler<HTMLInputElement> | undefined} checked
 * @property {string} imageUrl
 * @property {string} imageDesc
 */

export const CheckboxWithImg = (
  /** @type {CheckboxWithImgProps} */ {
    id,
    name,
    text,
    checked = false,
    onChange,
    imageUrl,
    imageDesc,
    isSubmitted,
  }
) => {
  const handleKeyDown = (event) => {
    if (event.key === ' ' && !isSubmitted) {
      event.preventDefault();
      onChange({ target: { checked: !checked } });
    }
  };

  return (
    <label
      className="c-checkbox-with-img"
      onKeyDown={handleKeyDown}
      tabIndex={0}
      aria-label={text || 'checkbox'}
    >
      {imageUrl && (
        <Image
          className="c-checkbox-with-img__img"
          ImageUrl={imageUrl}
          Alt={imageDesc}
        />
      )}
      {text && <span className="c-checkbox-with-img__text">{text}</span>}
      <input
        className="c-checkbox-with-img__input"
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        tabIndex={-1}
        disabled={isSubmitted}
        aria-disabled={isSubmitted}
      />
      <div className="c-checkbox-with-img__icon"></div>
    </label>
  );
};
